
export enum ObservationLanguageEnum {
    GB = 'GB',
    DE = 'DE'
}